<div *ngIf="filter" class="card m-1">
    <div class="card-body p-0">
        <div class="card-body d-flex flex-fill">
            <div class="d-flex flex-column flex-fill">
                <div class="d-flex flex-fill">
                    <div class="dx-field-label" style="max-width: 110px; min-width: 110px; overflow: unset; text-overflow: unset">Select Statuses</div>
                    <dx-tag-box class="flex-fill" [items]="statuses" [(value)]="selectedStatuses" valueExpr="id" displayExpr="name" [showSelectionControls]="true"></dx-tag-box>
                </div>
                <div class="d-flex mt-2">
                    <div class="dx-field-label" style="max-width: 160px; min-width: 160px; overflow: unset; text-overflow: unset">Include Vendor Pickups</div>
                    <dx-check-box [(value)]="showVendorPickups"></dx-check-box>
                </div>
                <div class="d-flex mt-2">
                    <button class="btn btn-sm btn-success" (click)="searchByStatus()">Search</button>
                    <button class="ms-2 btn btn-sm btn-secondary" (click)="clear()">Clear</button>
                    <button class="ms-2 btn btn-sm btn-secondary" (click)="toggleParts()">Toggle Lists</button>
                    <div class="dx-field-label ms-3" style="max-width: 110px; min-width: 110px; overflow: unset; text-overflow: unset">{{ markers?.length }} found</div>
                <!-- </div>
                <div class="d-flex"> -->
                    <div class="column ms-2 me-2"><span class="color-legend map-genesis"></span> - Genesis</div>
                    <div class="column ms-2 me-2"><span class="color-legend map-cpu-dpu"></span> - CPU/DPU</div>
                    <div class="column ms-2 me-2"><span class="color-legend map-third-party"></span> - Third Party</div>
                    <div class="column ms-2 me-2"><span class="color-legend map-vendor-pickups"></span> - Vendor Pickups</div>                    
                    <div class="column ms-2 me-2"><span class="color-legend map-tbd"></span> - TBD</div>                    
                    <div class="column ms-2 me-2"><span class="color-legend map-ups"></span> - UPS</div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-fill flex-row">
            <div class="d-flex flex-fill p-1" style="border: 1px solid">
                <dx-map
                    #map
                    class="tool-tip-class"
                    [apiKey]="keys"
                    provider="azure"
                    [autoAdjust]="false"
                    [center]="'Holland, MI'"
                    [zoom]="5"
                    [controls]="true"
                    height="800"
                    width="100%"
                ></dx-map>
            </div>
            <div class="d-flex col-sm-7 p-2 ms-1" style="border: 1px solid">
                <div class="grid-fill" *ngIf="orderLineDetails">
                    <dx-data-grid
                        #dataGrid
                        keyExpr="id"
                        [dataSource]="orderLineDetails"
                        class="map-data-grid"
                        [showBorders]="true"
                        height="800"
                        [columnAutoWidth]="false"
                        (onToolbarPreparing)="onToolbarPreparing($event)"
                        (onExporting)="onExporting($event)"
                    >
                        <dxi-column dataField="confirmationApproved" caption="Confirmation" width="100"></dxi-column>
                        <dxi-column dataField="dueDate" caption="Due Date" width="100"></dxi-column>
                        <dxi-column dataField="orderLine.order.dealer.companyName" caption="Dealer" width="100" [sortIndex]="2" sortOrder="asc"></dxi-column>
                        <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" width="65"></dxi-column>
                        <dxi-column dataField="orderLine.partNumber" caption="Part #" width="125"></dxi-column>
                        <dxi-column dataField="orderLine.description" caption="Description" width="125"></dxi-column>
                        <dxi-column dataField="status.name" caption="Status" width="100"></dxi-column>
                        <dxi-column dataField="vIN" caption="Vin #" width="100"></dxi-column>
                        <dxi-column dataField="orderLine.order.invoiceNumber" caption="Order #" width="80" cellTemplate="linkTemplate"></dxi-column>
                        <dxi-column dataField="optionHTML" caption="Options" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
                        <dxi-column dataField="noteHTML" caption="Notes" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
                        <dxi-column dataField="deliveryOption.name" caption="Delivery" width="100"></dxi-column>

                        <div *dxTemplate="let item of 'faTemplate'" class="d-flex">
                            <i *ngIf="item.data.paidViaACH" class="fa fa-usd ms-2" style="color: #1b8600" title="Paid via ACH"></i>
                        </div>

                        <div *dxTemplate="let cell of 'linkTemplate'">
                            <a [routerLink]="'/sales-orders/' + cell.data.orderId">{{ cell.value || '(blank)' }}</a>
                        </div>
                        <div *dxTemplate="let cell of 'printTemplate'">
                            <a [routerLink]="" (click)="printPDF(cell)">{{ cell.value || '' }}</a>
                        </div>

                        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
                        <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                        <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                        <dxo-selection mode="multiple"></dxo-selection>

                        <div *dxTemplate="let data of 'toolbarButtons'">
                            <button class="btn btn-sm btn-success me-2" (click)="addToList('build')" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                                Build
                            </button>
                            <button class="btn btn-sm btn-success me-2" (click)="addToList('ship')" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Ship</button>
                            <button class="btn btn-sm btn-secondary me-2" (click)="removeFromOrder()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                                Remove
                            </button>
                        </div>

                        <div *dxTemplate="let data of 'toolbarText'">
                            <span *ngIf="markers" class="me-3"
                                ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                            >
                        </div>
                    </dx-data-grid>
                </div>
            </div>
            <div *ngIf="!!showSideBar" class="d-flex flex-column flex-fill" style="max-width: 350px">
                <div
                    *ngIf="!!showSideBar && !!selectedBuildParts && selectedBuildParts.length > 0"
                    class="flex-fill"
                    style="max-width: 350px"
                    [hidden]="selectedBuildParts.length === 0"
                >
                    <div class="ps-2 pe-2">
                        <h4>Build Parts</h4>
                        <button class="ms-2 mb-2 btn btn-sm btn-secondary" (click)="printBuildList('build')">Print</button>
                        <table [hidden]="!selectedBuildParts || selectedBuildParts.length === 0" class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dealer</th>
                                    <th>Part #</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr [hidden]="selectedBuildParts.length > 0">
                                    <td colspan="9">No items</td>
                                </tr>
                                <tr [hidden]="selectedBuildParts.length === 0" *ngFor="let info of selectedBuildParts">
                                    <td class="col-xs-10">{{ info.orderLine.order.dealer.companyName }}</td>
                                    <td class="col-xs-10">{{ info.orderLine.partNumber }}</td>
                                    <td class="col-xs-2"><i class="fa fa-close" (click)="removeFromSelected(info, 'build')"></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div
                    *ngIf="!!showSideBar && !!selectedShipParts && selectedShipParts.length > 0"
                    class="flex-fill"
                    style="max-width: 350px"
                    [hidden]="selectedShipParts.length === 0"
                >
                    <div class="ps-4 pe-4">
                        <h4>Ship Parts</h4>
                        <button class="ms-2 btn btn-sm btn-secondary" (click)="printBuildList('ship')">Print</button>
                        <table [hidden]="!selectedShipParts || selectedShipParts.length === 0" class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dealer</th>
                                    <th>Part #</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr [hidden]="selectedShipParts.length > 0">
                                    <td colspan="9">No items</td>
                                </tr>
                                <tr [hidden]="selectedShipParts.length === 0" *ngFor="let info of selectedShipParts">
                                    <td class="col-xs-10">{{ info.orderLine.order.dealer.companyName }}</td>
                                    <td class="col-xs-2">{{ info.orderLine.partNumber }}</td>
                                    <td class="col-xs-2"><i class="fa fa-close" (click)="removeFromSelected(info, 'ship')"></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="markers">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="markers"
            [showBorders]="true"
            height="800"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="onRowPrepared($event)"
        >
            <dxi-column dataField="id" width="50"></dxi-column>
            <dxi-column dataField="dealer" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="vendor" caption="Vendor" width="200"></dxi-column>
            <dxi-column dataField="location" caption="Location" width="200"></dxi-column>
            <dxi-column dataField="city" caption="City" width="100"></dxi-column>
            <dxi-column dataField="state" caption="State" width="80"></dxi-column>
            <dxi-column dataField="pONumber" caption="PO#" width="100" cellTemplate="pOTemplate"></dxi-column>
            <dxi-column dataField="scheduledDate" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="numberOfSkids" width="100"></dxi-column>
            <dxi-column dataField="totalWeight" width="100"></dxi-column>
            <dxi-column dataField="deliveryOption" width="100"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

            <div *dxTemplate="let cell of 'pOTemplate'">
                <a [routerLink]="[]" (click)="openPO(cell.data)">{{ cell.value }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="markers" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
